export default __webpack_public_path__ + "static/media/Babai-fishing-game-1.5c9d345c.jpg";